export const BASE_URL = "https://glints-talent-pool.herokuapp.com";
